import { finalizeGeocodedAddressFields, type ContributionAddressFields } from './contributionAddress';

/**
 * Prepare reverse-geocode results for the contribution form.
 * Boundary names already come from /v1/reverse-geocode — avoid extra DB round-trips.
 */
export function resolveCanonicalAdminFields(fields: ContributionAddressFields): ContributionAddressFields {
  return finalizeGeocodedAddressFields(fields);
}
